// extracted by mini-css-extract-plugin
module.exports = {"postsWrapper":"posts-module--postsWrapper--2CmME","postCard":"posts-module--postCard--_PQ9n"};